import { LBLabel, LBRadioGroup, LBRadioGroupItem } from '@linearb/buzz';

interface TokenOption {
  name: string;
  value: string;
}

interface TokenTypeSelectorProps {
  options: TokenOption[];
  value: string;
  onChange: (value: string) => void;
}

function TokenTypeSelector({
  options,
  value,
  onChange
}: TokenTypeSelectorProps) {
  return (
    <LBRadioGroup value={value} onValueChange={value => onChange(value)}>
      <div className='flex flex-row gap-4 mb-4'>
        {options.map(option => {
          return (
            <div className='flex gap-2 items-center' key={option.value}>
              <LBRadioGroupItem id={option.value} value={option.value} />
              <LBLabel htmlFor={option.value}>{option.name}</LBLabel>
            </div>
          );
        })}
      </div>
    </LBRadioGroup>
  );
}

export default TokenTypeSelector;
